import { render } from "./box_s_probiotic.vue?vue&type=template&id=246aa7d4"
import script from "./box_s_probiotic.vue?vue&type=script&setup=true&lang=js"
export * from "./box_s_probiotic.vue?vue&type=script&setup=true&lang=js"

import "./box_s_probiotic.vue?vue&type=style&index=0&id=246aa7d4&lang=scss&scope=true"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/views/campaign/luckybox/box_s_probiotic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "246aa7d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('246aa7d4', __exports__)) {
    console.log('reload')
    api.reload('246aa7d4', __exports__)
  }
  
  module.hot.accept("./box_s_probiotic.vue?vue&type=template&id=246aa7d4", () => {
    console.log('re-render')
    api.rerender('246aa7d4', render)
  })

}


export default __exports__